import styled from 'styled-components'

export const ActionsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`
